import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DateAdapter } from '@angular/material/core';
import { AnnouncementService } from 'src/app/church-activities/data/services/anouncement.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';

@Component({
  selector: 'upade-announcement',
  templateUrl: './upade-announcement.component.html',
  styleUrls: ['./upade-announcement.component.sass']
})
export class UpadeAnnouncementComponent implements OnInit {
  editForm: FormGroup;
  isEditable: boolean = true; // Always allow editing

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<UpadeAnnouncementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dateAdapter: DateAdapter<Date>,
    private announcementService: AnnouncementService,
    private snackbar: SnackbarService
  ) {
    // Set the locale for date formatting
    this.dateAdapter.setLocale('en-US');

    // Initialize the edit form with controls and validators
    this.editForm = this.fb.group({
      title: ['', Validators.required],
      announcementCategory: ['', Validators.required],
      announcementDate: ['', Validators.required],
      message: ['', Validators.required],
      status: ['']  // Include the status control for updating status if needed
    });
  }
  
  ngOnInit(): void {
    // Pre-populate form with announcement data received via MAT_DIALOG_DATA
    // Convert announcementDate to a formatted string (yyyy-MM-dd) so it displays correctly in the date input.
    this.editForm.patchValue({
      title: this.data.data.title,
      announcementCategory: this.data.data.announcementCategory,
      announcementDate: this.formatDate(new Date(this.data.data.announcementDate)),
      message: this.data.data.message,
      status: this.data.data.status
    });
    this.isEditable = true;
  }

  /**
   * Formats a Date object into a 'yyyy-MM-dd' string.
   */
  private formatDate(date: Date): string {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) { month = '0' + month; }
    if (day.length < 2) { day = '0' + day; }

    return [year, month, day].join('-');
  }

  onUpdate(): void {
    if (this.editForm.invalid) {
      return;
    }
    
    // Get the updated data from the form
    const updatedData = this.editForm.value;
    // Ensure the announcementDate is formatted correctly for the API
    updatedData.announcementDate = this.formatDate(new Date(updatedData.announcementDate));
    
    const id = this.data.data.id;
    
    console.log("Updating announcement with id:", id);
    console.log("Updated data:", updatedData);
    
    this.announcementService.updateAnnouncement(id, updatedData).subscribe(
      (res) => {
        console.log("Update response:", res);
        this.snackbar.showNotification("snackbar-success", "Announcement updated successfully!");
        this.dialogRef.close(true);
      },
      (err) => {
        console.error("Error updating announcement:", err);
        this.snackbar.showNotification("snackbar-danger", "Failed to update announcement. Error: " + JSON.stringify(err));
      }
    );
  }
  
  onCancel(): void {
    this.dialogRef.close();
  }
}
